import { memo, ReactElement } from 'react';

import { IconButton } from '@components/icon-button';
import { IconFlagDK } from '@components/icons/flag-dk';
import { IconFlagGB } from '@components/icons/flag-gb';
import { IconFlagIS } from '@components/icons/flag-is';
import { Menu } from '@components/menu';
import { LocaleCode } from '@locale/locale-store';
import { setLocale, useLocale } from '@locale/translate';

export type LanguageSwitcherMenuProps = {
  enabled: LocaleCode[];
};

export const LanguageSwitcherMenu = memo<LanguageSwitcherMenuProps>(({ enabled }) => {
  const selected = useLocale<LocaleCode>();

  if (enabled.length < 2) {
    return null;
  }

  return (
    <Menu
      trigger={IconButton}
      triggerProps={{
        variant: 'ghost-purple',
        icon: iconMap[selected],
      }}
    >
      {enabled.map((language) => (
        <Menu.Item
          isActive={language === selected}
          key={language}
          onSelect={() => setLocale(language)}
          icon={iconMap[language]}
          label={labelMap[language]}
        />
      ))}
    </Menu>
  );
});

const iconMap: Record<LocaleCode, ReactElement> = {
  en: <IconFlagGB />,
  is: <IconFlagIS />,
  dk: <IconFlagDK />,
};

const labelMap: Record<LocaleCode, string> = {
  en: 'English',
  is: 'Íslenska',
  dk: 'Dansk',
};
